var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.283,
    height: 18.143,
    viewBox: "0 0 25.283 18.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list",
    transform: "translate(-1.093 -78.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5192",
    "data-name": "Group 5192",
    transform: "translate(6.377 86.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5191",
    "data-name": "Group 5191",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M143.23,236H125.294a1.26,1.26,0,0,0,0,2.478H143.23a1.26,1.26,0,0,0,0-2.478Z",
    transform: "translate(-124.262 -236)",
    fill: "#5861ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5194",
    "data-name": "Group 5194",
    transform: "translate(6.377 78.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5193",
    "data-name": "Group 5193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M143.23,86H125.294a1.248,1.248,0,0,0,0,2.458H143.23a1.248,1.248,0,0,0,0-2.458Z",
    transform: "translate(-124.262 -86)",
    fill: "#5861ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5196",
    "data-name": "Group 5196",
    transform: "translate(6.377 94.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5195",
    "data-name": "Group 5195",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M143.23,386H125.294a1.261,1.261,0,0,0,0,2.479H143.23a1.261,1.261,0,0,0,0-2.479Z",
    transform: "translate(-124.262 -386)",
    fill: "#5861ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5198",
    "data-name": "Group 5198",
    transform: "translate(1.093 79.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5197",
    "data-name": "Group 5197"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 0)",
    fill: "#5861ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5200",
    "data-name": "Group 5200",
    transform: "translate(1.093 86.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5199",
    "data-name": "Group 5199"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_636",
    "data-name": "Ellipse 636",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 0)",
    fill: "#5861ae"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5202",
    "data-name": "Group 5202",
    transform: "translate(1.093 94.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5201",
    "data-name": "Group 5201"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_637",
    "data-name": "Ellipse 637",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0 0)",
    fill: "#5861ae"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1eb321f8377b6bf15b814257ac1c0cb0.svg";
export { ForwardRef as ReactComponent };